import { createApp } from 'vue'
import AppView from './App.vue'
import { createPinia } from 'pinia'
import router from '@/router'
import VConsole from 'vconsole'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/style/app.less'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
if (import.meta.env.VITE_VCONSOLE === 'true') new VConsole()
const app = createApp(AppView)
const pinia = createPinia() // 创建 Pinia 实例

app.use(ElementPlus, {
  locale: zhCn // 使用中文
}).use(pinia).use(router).mount('#app')
